import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../toast/Toasts";
import { ITopupRequestDetails } from "../topupModel";
import moment from "moment";

export const getAllTopupRequests = createAsyncThunk(
  "TopupRequest/FindAllTopupRequest",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TopupRequest/FindAllTopupRequest`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Topup Requests:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const insertTopupRequest = createAsyncThunk(
  "TopupRequest/InsertTopupRequest",
  async (CountryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TopupRequest/InsertTopupRequest`,
        CountryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Topup Request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTopupRequest = createAsyncThunk(
  "TopupRequest/UpdateTopupRequest",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TopupRequest/UpdateTopupRequest`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Topup Request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTopupRequestByID = createAsyncThunk(
  "TopupRequest/FindByIDTopupRequest",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TopupRequest/FindByIDTopupRequest`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ...result,
        TransactionDate: result?.TransactionDate
          ? moment(result?.TransactionDate, "YYYY-MM-DD").toDate()
          : "",
      } as ITopupRequestDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Topup Request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteTopupRequest = createAsyncThunk(
  "TopupRequest/DeleteTopupRequest",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TopupRequest/DeleteTopupRequest`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Topup Request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveBanks = createAsyncThunk(
  "Bank/FindAllActiveBank",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Bank/FindAllActiveBank`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Banks:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveBankAccounts = createAsyncThunk(
  "BankAccount/FindAllActiveBankAccount",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/BankAccount/FindAllActiveBankAccount`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Bank Accounts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
